import React, { PureComponent } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { ThemeContext } from 'utils/theme';
import { isMedium } from 'utils/detection';

import Wrapper from './styled/Wrapper';
import ProjectListItem from './styled/ProjectListItem';
import Title from './styled/Title';

export default class OfferSection extends PureComponent {
  static defaultProps = {
    title: 'Works',
  };

  static contextType = ThemeContext;

  state = {
    activeProject: null,
    isMedium: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onMouseEnter = project => {
    this.setState({ activeProject: project });
  };

  onMouseLeave = () => {
    this.setState({ activeProject: null });
  };

  onResize = () => {
    this.setState({ isMedium: isMedium() });
  };

  render() {
    const { projects, title } = this.props;
    const { activeProject, isMedium } = this.state;

    return (
      <Wrapper>
        <Title theme={this.context}>{title}</Title>
        <AnimatePresence>
          <motion.div layout>
          {projects.map((project, index) => (
            <ProjectListItem
              key={project.slug}
              project={project}
              isActive={activeProject === project}
              isInactive={activeProject !== null && activeProject !== project}
              onMouseEnter={() => this.onMouseEnter(project)}
              onMouseLeave={this.onMouseLeave}
              index={index}
              baseLink="/projects"
              isMedium={isMedium}
            />
          ))}
          </motion.div>
        </AnimatePresence>
      </Wrapper>
    );
  }
}
